export * from './image-properties.component';
